import { getEnabled } from "../actions/feature_flags";

export const fetchGetFeatureFlags = (dispatch: any) => (key: any, featureName: string) =>
  dispatch(getEnabled(featureName));
